import { createSelector } from 'reselect';

import getCartHasAddressId from './getCartHasAddressId';
import getCartHasCoords from './getCartHasCoords';

const getCartHasLocation = createSelector(
  getCartHasAddressId,
  getCartHasCoords,
  (hasId, hasCoords) => hasId || hasCoords,
);

export default getCartHasLocation;
